<!--
 * @Description  : 安招采服务管理 -- 平台技术服务费下方内容
 * @Author       : 王帅
 * @Date         : 2026-07-14 16:38:03
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-07-14 16:54:32
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\platform-services\azc-components\tab-skill.vue
-->
<template>
	<div class="tab-content">
		<div class="content-header">
			<div class="text-box">
				<span v-if="isHit == 0" class="color-red">当前服务未上架</span>
				<span v-if="isHit == 1" class="color-success">当前服务已上架，生效时间：{{ effectDate }}</span>
			</div>
			<div class="btn-box">
				<el-button type="primary" class="btn-blue" size="small" @click="handleBtn('add')">
					包年配置
				</el-button>
				<el-button type="primary" class="btn-blue ml10" size="small" @click="doExport">
					导出
				</el-button>
			</div>
		</div>
		<!-- 非请求参数 正常查看 -->
		<div class="w-table-layout w-table-page">
			<div class="w-table-content bd-table">
				<el-table ref="xTable" highlight-current-row :data="filterData" height="100%" border>
					<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>

					<el-table-column prop="payType" label="服务类型" header-align="left" min-width="150" show-overflow-tooltip>
						<template #default="{ row }">
							<span v-if="row.payType == 0">平台技术服务费（包年）</span>
						</template>
					</el-table-column>
					<el-table-column prop="tenantName" label="开通单位" header-align="left" min-width="200" show-overflow-tooltip></el-table-column>
					<el-table-column prop="creditCode" label="税号" header-align="left" min-width="150" show-overflow-tooltip></el-table-column>
					<el-table-column prop="createUser" label="开通人" align="left" width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="money" label="支付金额（元）" align="right" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="openTime" label="开通时间" align="left" width="150" show-overflow-tooltip></el-table-column>
					<el-table-column prop="expirationDate" label="服务有效期" align="left" width="180" show-overflow-tooltip> </el-table-column>
					<el-table-column prop="status" label="生效状态" align="left" width="100" show-overflow-tooltip>
						<template #default="{ row }">
							<span v-if="row.status == 1">已生效</span>
							<span v-else-if="row.status == 2">未生效</span>
							<span v-else-if="row.status == 3">已失效</span>
						</template>
					</el-table-column>
					<el-table-column align="left" width="180" label="操作">
						<template #default="{ row }">
							<el-button type="primary" size="small" round plain class="table-btn" @click="handleBtn('detail', row)">
								查看
							</el-button>
							<el-button
								type="primary"
								size="small"
								v-if="row.allowClose == 1"
								round
								plain
								class="table-btn"
								@click="handleBtn('close', row)"
							>
								关闭包年服务
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="w-table-footer">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="pageList"
					:page-size="pageSize"
					:total="total"
					layout="total, sizes, prev, pager, next, jumper"
				>
				</el-pagination>
			</div>
		</div>

		<!-- 包年配置 -->
		<addDialog v-if="isAdd" ref="addDalog" @change="getData"></addDialog>
		<!-- 关闭包年服务 -->
		<close-dialog v-if="closeShowDialog" ref="close_dialog" @update="getData"></close-dialog>
		<!-- 详情 -->
		<detailDialog ref="detailDialog"></detailDialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { exportPlus } from 'utils/tools'
import * as Api from '@/api/modules/platform-service/index'

// components
import addDialog from '../components/addDialog.vue'
import CloseDialog from '../components/close-dialog.vue'
import detailDialog from '../components/detailDialog.vue'

export default {
	name: '',
	components: { addDialog, detailDialog, CloseDialog },
	props: {
		searchForm: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			filterData: [],
			loading: false,
			tableShow: true,
			pageList: [10, 20, 30, 50, 100], // 显示条数数组
			currentPage: 1, // 当前页码
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			isHit: null, // 是否上下架
			isAdd: false,
			closeShowDialog: false,
			effectDate: '' // 生效时间
		}
	},
	methods: {
		//获得列表数据
		getData(isBack) {
			this.filterData = []
			let params = {}
			this.loading = true

			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize

			// 查询参数
			params.invoiceStatus = this.searchForm.payStatus || 0
			params.tenantName = this.searchForm.payCompanyName || ''
			params.creditCode = this.searchForm.payCompanyCreditcode || ''

			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				params.startOfOpenTime = this.searchForm.dateArr[0] + ' 00:00:00'
				params.endOfOpenTime = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				params.startOfOpenTime = ''
				params.endOfOpenTime = ''
			}

			Api.selectServiceFeePage(params)
				.then((res) => {
					const data = res.data.serviceFeePage
					this.filterData = data.records
					this.currentPage = parseInt(data.current)
					this.total = parseInt(data.total)
					this.pageSize = parseInt(data.size)
					// 是否上下架
					this.isHit = res.data.isHit || 0
					// 生效时间
					this.effectDate = res.data.effectDate
				})
				.catch((err) => {
					this.isHit = 0
				})
				.finally(() => {
					this.loading = false
					setTimeout(() => {
						this.$refs.table ? this.$refs.table.doLayout() : ''
					}, 500)
				})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 重置
		doReset() {
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		// 按钮操作
		handleBtn(type, row) {
			switch (type) {
				case 'add':
					this.isAdd = true
					setTimeout(() => {
						this.$refs.addDalog.visible = true
						this.$refs.addDalog.initData()
					}, 200)

					break
				case 'detail':
					this.$refs.detailDialog.visible = true
					this.$refs.detailDialog.getDetail(row.id)
					break
				case 'close':
					this.closeShowDialog = true
					setTimeout(() => {
						// this.$refs.addDalog.visible = true;
						this.$refs.close_dialog.initDialog(row.id)
					}, 200)
					break
			}
		},
		//导出
		doExport() {
			let params = {
				invoiceStatus: this.searchForm.invoiceStatus ? this.searchForm.invoiceStatus : 0,
				tenantName: this.searchForm.tenantName ? this.searchForm.tenantName : '',
				creditCode: this.searchForm.creditCode ? this.searchForm.creditCode : '',
				startOfOpenTime: this.searchForm.times ? this.searchForm.times[0] : '',
				endOfOpenTime: this.searchForm.times ? this.searchForm.times[1] : '',
				columns: [
					{
						field: 'index',
						title: '序号'
					},
					{
						field: 'payType',
						title: '服务类型'
					},
					{
						field: 'tenantName',
						title: '开通单位'
					},
					{
						field: 'creditCode',
						title: '税号'
					},
					{
						field: 'createUser',
						title: '开通人'
					},
					{
						field: 'money',
						title: '支付金额（元）'
					},
					{
						field: 'openTime',
						title: '开通时间'
					},
					{
						field: 'expirationDate',
						title: '服务有效期'
					},
					{
						field: 'status',
						title: '生效状态'
					}
				]
			}

			let path = '/userTenantCenter/expertServiceFee'
			//let path = 'http://172.16.0.50:8082'+ '/userTenantCenter/expertServiceFee'
			exportPlus(path, params)
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		...mapState('user', { userInfo: (state) => state.userInfo }),

		// 支付状态码表
		statusArr() {
			let arr = [
				{ value: '0', label: '生效中' },
				{ value: '1', label: '已失效' },
				{ value: '2', label: '已关闭' },
				{ value: '3', label: '待生效' }
			]

			return arr
		},

		// 不同码表展示的文字
		statusText() {
			let text = ''
			let that = this
			return function(type, value) {
				switch (type) {
					// 服务类型
					case 'goodsCode':
						text = value !== '' ? ['新办', '续费'][parseFloat(value)] : ''
						break
					// 状态
					case 'payStatus':
						let item = that.statusArr.find((x) => parseFloat(x.value) === parseFloat(value))
						text = item && item.label ? item.label : ''
						break
				}
				return text
			}
		},

		// 日期选择快捷选项
		pickerOptions() {
			let that = this
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			return {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							console.log('😍 ~ picker:', picker)
							picker.$emit('pick', [dayStart, dayEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [monthStart, monthEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '本年',
						onClick(picker) {
							picker.$emit('pick', [yearStart, yearEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					}
				]
			}
		}
	}
}
</script>
<style scoped lang="less">
.tab-content {
	height: 100%;
	display: flex;
	flex-direction: column;

	.content-header {
		padding: 10px 0;
		display: flex;
		justify-content: space-between;

		.text-box {
			font-size: 14px;
		}

		.btn-box {
			margin-left: auto;
		}
	}

	.w-table-layout {
		flex: 1;
	}
}
</style>
